// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"cfeeee1a","8243":"cfeeee1a","8737":"2b2828cd"}[chunkId] + ".chunk.css";
};